import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndirectJobsFeaturesComponent } from './features/indirect-jobs-features.component';
import { IndirectJobsPresentersComponent } from './presenters/indirect-jobs-presenters.component';
import { ExpensesModule } from '../expenses';
import {
    DropdownModule,
    MultiSelectModule,
    MenuModule,
    PopoverModule,
    ToolbarModule,
    ButtonModule,
    TreeTableModule,
    CheckboxModule
} from '../shared/efaact-primeng.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EfaactMaterialModule } from '../efaact-material/efaact-material.module';
import { EffectsModule } from '@ngrx/effects';
import { IndirectJobsEffects } from './store/effects';
import { StoreModule } from '@ngrx/store';
import * as fromIJ from './store/reducer';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature('indirectjobs', fromIJ.reducer),
        EffectsModule.forFeature([IndirectJobsEffects]),
        EfaactMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        MultiSelectModule,
        DropdownModule,
        ExpensesModule,
        MenuModule,
        PopoverModule,
        ToolbarModule,
        ButtonModule,
        TreeTableModule,
        CheckboxModule
    ],
    declarations: [
        IndirectJobsFeaturesComponent,
        IndirectJobsPresentersComponent
    ]
})
export class IndirectJobsModule {}
